//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import universalSourceActionsMenuTemplate from '@legacy-components/common/universal-source-actions/universal-source-actions-menu.html';

(function () {
  angular.module('curalate').component('universalSourceActionsMenu', {
    template: universalSourceActionsMenuTemplate,
    bindings: {
      isTracked: '<',
      onTrack: '&',
      onUntrack: '&',
      secondarySourceId: '<',
      sourceId: '<',
      sourceType: '<',
      trackingCategory: '<',
      user: '<',
      isIgBusinessAccountConnected: '<',
    },
    controller: [
      'PermissionsService',
      'TrackingService',
      function (PermissionsService, TrackingService) {
        this.trackAction = `${TrackingService.CATEGORY_UNIVERSAL_SOURCE_ACTIONS}:${TrackingService.ACTION_EXPLORE_TRACK_SOURCE}`;
        this.untrackAction = `${TrackingService.CATEGORY_UNIVERSAL_SOURCE_ACTIONS}:${TrackingService.ACTION_EXPLORE_UNTRACK_SOURCE}`;

        this.positioningStrategy = {
          fixed: ['right', 'left'],
          align: ['top', 'bottom'],
        };
      },
    ],
  });
})();
